import { render, staticRenderFns } from "./UserInformationCards.vue?vue&type=template&id=301811f4&"
import script from "./UserInformationCards.vue?vue&type=script&lang=js&"
export * from "./UserInformationCards.vue?vue&type=script&lang=js&"
import style0 from "./UserInformationCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports